export const PromotionErrorExtensions = {
  PROMOTION_INVALID: 'PROMOTION_INVALID',
  PROMOTION_NOT_FOUND: 'PROMOTION_NOT_FOUND',
  PROMOTION_EXPIRED: 'PROMOTION_EXPIRED',
  PROMOTION_NOT_ELIGIBLE: 'PROMOTION_NOT_ELIGIBLE',
  PROMOTION_ALREADY_REDEEMED: 'PROMOTION_ALREADY_REDEEMED',
} as const;
